import React from 'react';
import styles from './styles/ViewSubTypeForYearRadioBar.module.css';

/** ViewSubTypeForYearRadioBar is view used to show radio button for show, choose to show all or daily average. */
const ViewSubTypeForYearRadioBar = (props) => {
  const onChange = (e) => {
    if (typeof props.onChangeSubViewType === 'function') {
      props.onChangeSubViewType(e.target.value);
      return;
    }
  };
  const viewSubType = props.viewSubType;
  const containerClassName = 'flex items-center mr-4';
  const labelClassName = 'ml-2 text-lg font-normal  text-gray-900 dark:text-gray-300';

  return (
    <div className='flex flex-row'>
      <div className={containerClassName}>
        <label className={styles.container}>
          <span className={labelClassName}>{props.t('1_year_summary')}</span>
          <input
            type='radio'
            checked={viewSubType === 'summary' ? true : false}
            onChange={onChange}
            id='input_summary'
            value='summary'
            name='bordered-radio'
          />
          <span className={styles.checkmark}></span>
        </label>
      </div>
      <div className={containerClassName}>
        <label className={styles.container}>
          <span className={labelClassName}>{props.t('1_year_average')}</span>
          <input
            type='radio'
            checked={viewSubType === 'average' ? true : false}
            onChange={onChange}
            id='input_average'
            value='average'
            name='bordered-radio'
          />
          <span className={styles.checkmark}></span>
        </label>
      </div>
    </div>
  );
};

export default ViewSubTypeForYearRadioBar;
